import { fetchGET, fetchPUT } from '@enuan/m3mgr-utils';
import { CONFIGURATOR_API_URLS } from './consts';
import {
	ConfigurationItem,
	IBaseConfiguratorConfiguration,
	IConfiguratorConfiguration,
} from './types';
import { configurationItemAdapter } from './adapter';

export const fetchConfig = (
	configName: string
): Promise<IConfiguratorConfiguration> =>
	fetchGET<ConfigurationItem>(
		CONFIGURATOR_API_URLS.getModelUrl(configName)
	).then(configurationItemAdapter);

export const fetchList = (): Promise<IBaseConfiguratorConfiguration[]> => {
	const url = new URL(CONFIGURATOR_API_URLS.collectionUrl);
	url.search = new URLSearchParams({
		fields: ['state', 'localization', 'chat'].join(','),
	}).toString();
	return fetchGET<ConfigurationItem[]>(url.toString()).then((items) =>
		items.map<IBaseConfiguratorConfiguration>(configurationItemAdapter)
	);
};

export const putConfig = (
	configName: string,
	configuration: Partial<IConfiguratorConfiguration>
) =>
	fetchPUT<ConfigurationItem>(
		CONFIGURATOR_API_URLS.getModelUrl(configName),
		configuration
	).then(configurationItemAdapter);
